<template>
  <v-container>
    <v-card class="pa-4">
      <h4>Resubscribe</h4>
      <div class="subscriptions">
        <v-radio-group v-model="price_id">
          <v-row>
            <v-col
              lg="6"
              xs="12"
              v-for="subscription of subscriptions.data.filter(
                (sub) => sub.active != false
              )"
              :key="subscription.id"
            >
              <v-card v-if="subscription.active">
                <div class="pa-4 d-flex">
                  Amount :
                  {{ subscription.unit_amount / 100 }}
                  <v-radio
                    class="ml-auto"
                    name="amount"
                    :value="subscription.id"
                  />
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-radio-group>
      </div>
      <div class="my-3 mx-auto" style="max-width: 420px">
        <promo-code :info="(data) => lc_promocode_info(data)" />
      </div>
      <div class="d-flex align-items-center justify-center">
        <v-btn
          large
          color="primary"
          class="mt-4"
          :loading="loading"
          @click="lc_resub"
          >Resubscribe</v-btn
        >
      </div>
    </v-card>
  </v-container>
</template>

<script>
import PromoCode from "../components/PromoCode.vue";
export default {
  components: { PromoCode },
  data() {
    return {
      price_id: "",
      loading: false,
      promocodeInfo: {},
    };
  },
  mounted: function () {
    // this.mountCard();
    this.getSubscriptions();
  },
  methods: {
    async lc_promocode_info(info) {
      console.log(info);
      this.promocodeInfo = info;
    },
    async lc_resub() {
      this.loading = true;
      let obj = {
        price: this.price_id,
        customer_id: this.authUser.customer_id,
      };
      if (Object.keys(this.promocodeInfo) != 0) {
        obj["promotion_code"] = this.promocodeInfo.id;
      }
      await this.reSubscription(obj);
      await this.$router.push("/dashboard");
    },
  },
};
</script>

<style></style>
